// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__3gsjy","iconContainer":"Error_iconContainer__38OiG"};